import { permissionObj } from '../../../../../Helpers/permission';
import {GetConfigByName} from "../../../../../reduxToolkit/authentication/AuthenticatonApi";
import {SYSTEM_CONFIG_LIST} from "../../../Setting/Model/SettingConfigModel";
import QRCode from "qrcode";
import routes from "../../../../../Routes/routes";
import {toast} from "react-toastify";
import i18next from "i18next";

/**
 * @Author: Susana García Rodríguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 */

/**
 * TABS_GUARD
 * Defines the visitor module tabs with their index and translation key.
 */
export const TABS_GUARD = {
    VISITORS: {
        INDEX: 0,
        TRANS: 'visitors',
    },
    REQUESTS: {
        INDEX: 1,
        TRANS: 'active_request',
    },
};

/**
 * TAB_PERMISSION_GUARD
 * Maps permissions for actions (CREATE, DELETE, EXPORT, ADVANCE_SEARCH)
 * to the corresponding visitor tabs.
 */
export function TAB_PERMISSION_GUARD() {
    return {
        CREATE: {
            [TABS_GUARD.VISITORS.INDEX]: permissionObj?.WEB_VISITOR_CREATE,
        },
        DELETE: {
            [TABS_GUARD.VISITORS.INDEX]: permissionObj?.WEB_VISITOR_DELETE,
        },
        EXPORT: {},
        ADVANCE_SEARCH: {},
    };
}

/**
 * VISITOR_VIEWS_FROM
 * Constants representing the source views for visitor data.
 * VISITOR_MANAGEMENT corresponds to the employee view, and VISITOR_GUARD corresponds to the guard view.
 */
export const VISITOR_VIEWS_FROM = {
    VISITOR_MANAGEMENT: 0,
    VISITOR_GUARD: 1,
};
export const MODEL_CONTEXT = {
    tabIndex: null,
    disabledBtnDelete: true,
    modalCreate: false,
}


export const GUARD_REQUEST_MODEL = {
    comment: null,
    isValidReject: function () {
        return (
            typeof this.comment === 'string' &&
            this.comment.trim() !== ''
        );
    },
    toReject: function () {
        return {
            comment: this.comment,
        };
    },
};

export const MODAL_OPTIONS = {
    ASSIGN: "assign",
    REJECT: "reject"
}

export const handleDownloadQR = async (dispatch) => {
    const { payload } = await dispatch(GetConfigByName(SYSTEM_CONFIG_LIST.environmentUrl));
    const { data: responseData, success } = payload.data;
    if (!success) return;

    try {
        const image = await QRCode.toDataURL(responseData + routes.qrRequestAccess.qr, { width: 300 });
        const link = document.createElement('a');
        link.href = image;
        link.download = i18next.t("request_access") + ' QR.png';
        link.click();
    } catch (err) {
        toast.error(i18next.t('something_went_wrong_2 '));
    }
};
